module.exports = __webpack_public_path__ + "media/images/sp/stores/umeda/umeda_sns_02-9d35144b2d69c5a6a690f62ed27f9625.jpg";